import webStyles from './webStyles';
import mobileStyles from './mobileStyles';
import CreateResponsiveStyle from '../../../utils/create-responsive-styles';

const responsiveStyle = CreateResponsiveStyle(webStyles, mobileStyles);

export default responsiveStyle;
